/* ManagementStateComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl
    .DefaultColumnComponent;
const Renderer = require("./ManagementStateRenderer");
const _ = require("lodash");

class ManagementStateComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);
        this._value = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
        });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue(newVal) {
        if (!_.isNil(newVal)) {
            this._value = newVal;
            this.emit("ManagementState", newVal);
        }
        return this;
    }

    getValue() {
        return this._value;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ManagementStateComponent;
